/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["Planned"] = "Planned";
    ServiceStatus["InProgress"] = "InProgress";
    ServiceStatus["Completed"] = "Completed";
})(ServiceStatus || (ServiceStatus = {}));
export function ServiceStatusFromJSON(json) {
    return ServiceStatusFromJSONTyped(json, false);
}
export function ServiceStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ServiceStatusToJSON(value) {
    return value;
}
